
import { computed, useContext } from '@nuxtjs/composition-api';
import useCheckout from '~/composable/checkout/useCheckout';
import { CHECKOUT_FLOW } from '~/constants/CheckoutFlow';
export default {
  setup() {
    const { app } = useContext()
    const { checkoutType } = useCheckout(app)
    const categoryUrl = computed(() => {
      if (checkoutType.value === CHECKOUT_FLOW.WITH_MV_SUBSCRIPTION_ONLY) {
        return '/mobilabonnement'
      } else if (checkoutType.value === CHECKOUT_FLOW.DEVICE_WITH_SUBSCRIPTION) {
        return '/shop/mobiltelefoner'
      } else if (checkoutType.value === CHECKOUT_FLOW.WITH_MOBILE_BROADBAND_SUBSCRIPTION) {
        return '/internet'
      } else if (checkoutType.value === CHECKOUT_FLOW.WITH_OUT_SUBSCRIPTION) {
        return '/shop/tilbehoer'
      } else {
        return '/shop'
      }
    })
    return {
      categoryUrl
    }
  }
}
